module.exports = __webpack_public_path__ + "media/images/common/menu_top_bg-5a078d02b906a6d29e260f53b8c5cb6c.png";